module.exports = __webpack_public_path__ + "img/33ne.faa485b0.svg";